export const TOKEN_AUTH_FAILED =
  'Session expired, Please Log in again.'



// WEBPACK FOOTER //
// ./src/const.js